









































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteConveniosStore from '@/components/Suporte/Store/SuporteConveniosStore'
import { onlyNumber } from '@/utils/common'

@Component
export default class ComponentModalSuporteConvenioPlano extends Vue {
  loadSaveOrUpdateConvenioPlano: boolean = false

  get getSuporteConveniosStore() {
    return getModule(SuporteConveniosStore, this.$store)
  }

  get loadingSaveOrUpdateConvenioPlano() {
    return this.loadSaveOrUpdateConvenioPlano
  }

  set loadingSaveOrUpdateConvenioPlano(value: boolean) {
    this.loadSaveOrUpdateConvenioPlano = value
  }

  get showModalConvenioPlano() {
    return this.getSuporteConveniosStore.modal.convenioPlano
  }

  set showModalConvenioPlano(value: boolean) {
    this.getSuporteConveniosStore.setModal({ name: 'convenioPlano', value })
  }

  $refs!: {
    formConvenioPlano: any
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async saveOrUpdateConvenioPlano() {
    this.loadingSaveOrUpdateConvenioPlano = true

    if (this.$refs.formConvenioPlano.validate()) {
      const { mode } = this.getSuporteConveniosStore

      const response = await this.getSuporteConveniosStore.upsertConvenioPlanoHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Plano ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.showModalConvenioPlano = false
        this.$refs.formConvenioPlano.reset()
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o plano ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateConvenioPlano = false
  }

  @Watch('showModalConvenioPlano')
  async onChangeShowModalConvenioPlano(value: boolean) {
    if (!value) {
      this.getSuporteConveniosStore.clearNovoConvenioPlano()
      await this.getSuporteConveniosStore.getAllConvenioPlanoByConvenio()
      this.getSuporteConveniosStore.setMode({ mode: 'CREATE' })
      this.$refs.formConvenioPlano.reset()
    }
  }
}
